import React from "react";

export function Form({ children, className }) {
  return <form className={className}>{children}</form>;
}
